import Vue from 'vue';
import App from '@/App.vue';
import '@/components/Global/_globalImport';
import store from '@/store';
import { polyfill } from 'mobile-drag-drop';

// dnd polyfill for mobile
polyfill();

//fix for ios 10+
window.addEventListener('touchmove', function() {});

declare global {
  interface Window {
    fotowandDesigner: {
      setType?: (type: string) => void;
      setDimensions?: (dimensions: { type: string; width: number; height: number }) => void;
    };
  }
}
window.fotowandDesigner = {};

Vue.config.productionTip = false;
export default new Vue({
  store,
  data() {
    return {
      mode: null,
      inline: null,
      height: null,
      orderCallback: null,
      price: null,
      backend: null,
      storage: null,
      imagesMaxCount: null,
      imagesMaxSize: null,
    };
  },
  beforeMount() {
    const { inline, height, orderCallback, price, imagesMaxCount, imagesMaxSize } = this.$el.attributes;
    this.inline = inline ? !!inline.value : null;
    this.height = height ? height.value : null;
    this.price = price ? price.value : 1;
    this.orderCallback = orderCallback ? orderCallback.value : null;
    this.imagesMaxCount = imagesMaxCount ? parseInt(imagesMaxCount.value) : null;
    this.imagesMaxSize = imagesMaxSize ? parseInt(imagesMaxSize.value) : null;
  },
  render(h) {
    return h(App, {
      props: {
        inline: this.inline,
        height: this.height,
      },
    });
  },
}).$mount('#fotowand-designer');
